import type { LinkGridItem } from '@ui-rocco/pages/category-page/CategoryPageLinkGrid';
import type { CategoryTileViewModel } from '@rocco/ui/tile-category/view-models/category';

/**
 * Maps contextual professional category groups into flat internal-link mesh items.
 * Hub pages link to top-level categories; deeper pages link to sub-categories in
 * the current silo so the grid matches the location mesh styling.
 */
export const mapProfessionalCategoriesToLinkGridItems = (
    categories: CategoryTileViewModel[],
    isRoot: boolean,
): LinkGridItem[] => {
    if (isRoot) {
        return categories.map((category) => ({
            key: String(category.id),
            href: category.link,
            label: category.title,
        }));
    }

    return categories.flatMap((category) =>
        category.subCategories.map((subCategory) => ({
            key: `${category.id}-${subCategory.id}`,
            href: subCategory.link,
            label: subCategory.title,
        })),
    );
};
